export const matchesQuery = (itemOrString, query) => {
  if (!query) return true;
  const normalizeContent = (s) => (s || "").toLowerCase().replace(/[_\/\\\\]/g, " ");
  const item = typeof itemOrString === "string" ? { name: itemOrString } : itemOrString;
  const normalizedName = normalizeContent(item.name);
  const normalizedDesc = normalizeContent(item.description);
  const normalizedPath = normalizeContent(item.path);
  const combined = `${normalizedName} ${normalizedDesc} ${normalizedPath}`;
  const orParts = query.split(/\s+or\s+/i);
  return orParts.some((part) => {
    const terms = part.split(/\s+/).filter((t) => t);
    if (terms.length === 0) return true;
    return terms.every((term) => {
      const lowerTerm = term.toLowerCase();
      if (lowerTerm.startsWith("folder:")) {
        const folderQuery = normalizeContent(term.substring(7));
        if (!folderQuery) return true;
        if (item.type === "directory") {
          return normalizedName.includes(folderQuery);
        } else {
          const pathParts = (item.path || "").split(/[\/\\\\]/);
          const parentDirs = pathParts.slice(0, -1);
          return parentDirs.some((p) => normalizeContent(p).includes(folderQuery));
        }
      }
      if (lowerTerm.startsWith("in_inventory:") || lowerTerm.startsWith("ininventory:") || lowerTerm.startsWith("inventory:")) {
        const colonIdx = lowerTerm.indexOf(":");
        const val = lowerTerm.substring(colonIdx + 1).trim();
        const isInInv = item.inInventory !== void 0 ? Boolean(item.inInventory) : Boolean(item.in_inventory);
        if (val === "true" || val === "yes" || val === "1") {
          return isInInv === true;
        } else if (val === "false" || val === "no" || val === "0") {
          return isInInv === false;
        } else if (!val) {
          return true;
        } else {
          return String(isInInv).toLowerCase() === val;
        }
      }
      const normalizedTerm = normalizeContent(term);
      return combined.includes(normalizedTerm);
    });
  });
};
